var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppstralStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 814.8 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stellaGradient",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#e2c629",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dd47bf",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stellaGradient)",
    className: "cls-1",
    d: "M805.42,528.93l-240.12-40.02c-7.45-1.24-11.57-9.34-8.19-16.09l67.46-134.92c4.82-9.65-5.41-19.88-15.06-15.06l-128.72,64.36c-6.93,3.46-15.2-.96-16.16-8.65L418.54,9.83c-1.64-13.11-20.64-13.11-22.28,0l-46.09,368.71c-.96,7.69-9.23,12.11-16.16,8.65l-128.72-64.36c-9.65-4.83-19.89,5.41-15.06,15.06l67.46,134.92c3.38,6.76-.74,14.85-8.19,16.09l-240.12,40.02c-12.51,2.08-12.51,20.06,0,22.14l240.12,40.02c7.45,1.24,11.57,9.34,8.19,16.09l-61.96,123.92c-6.59,13.17,7.39,27.15,20.57,20.56l117.71-58.85c6.93-3.47,15.2.96,16.16,8.65l46.09,368.71c1.64,13.11,20.64,13.11,22.28,0l46.09-368.71c.96-7.69,9.23-12.11,16.16-8.65l128.72,64.36c9.65,4.83,19.89-5.41,15.06-15.06l-67.46-134.92c-3.38-6.76.74-14.85,8.19-16.09l240.12-40.02c12.51-2.08,12.51-20.06,0-22.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstralStar);
export default __webpack_public_path__ + "static/media/AppstralStar.7ce40272f8e3643c7880aff567cc8076.svg";
export { ForwardRef as ReactComponent };